import {
  CaretDownIcon,
  Icon,
  Link,
  Menu,
  Popover,
  Position,
  useTheme,
} from "evergreen-ui";
import React from "react";
import { Link as ReactLink, useLocation, useNavigate } from "react-router-dom";
import { LinkConfig } from "../../models";

interface DropdownButtonProps {
  items: LinkConfig[];
}
export const DropdownButton = ({ items = [] }: DropdownButtonProps) => {
  const location = useLocation();
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Popover
      position={Position.BOTTOM_LEFT}
      content={
        <Menu>
          <Menu.Group>
            {items.map((item) => (
              <Menu.Item
                key={item.to}
                onSelect={() => {
                  navigate(item.to);
                }}
              >
                {item.name}
              </Menu.Item>
            ))}
          </Menu.Group>
        </Menu>
      }
    >
      <Link
        key="link.name"
        is={ReactLink}
        marginRight={16}
        to={location.pathname}
        display="flex"
        color={theme.colors.white}
      >
        <span>Resources</span>
        <Icon
          icon={CaretDownIcon}
          size={12}
          marginLeft="0.1rem"
          marginY="auto"
        />
      </Link>
    </Popover>
  );
};
